import script from "./GGanttBarTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttBarTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttBarTooltip.vue?vue&type=style&index=0&id=4a21d162&lang=css"

const __exports__ = script;

export default __exports__